export default __webpack_public_path__ + "static/media/earth.eaf4c4ec.jpg";